var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{staticClass:"link",attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('h4',[_vm._v(_vm._s(_vm.props.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }